import { render } from "./estados.vue?vue&type=template&id=55ea0958"
import script from "./estados.vue?vue&type=script&lang=js"
export * from "./estados.vue?vue&type=script&lang=js"

import "./estados.vue?vue&type=style&index=0&id=55ea0958&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__